import { useEffect, useState } from "react";
import Parse from "services/parse.service";

export function useParseLiveQuery(className, objectId) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!className || !objectId) {
      return;
    }

    let subscription;
    let isActive = true;

    setData(null);

    (async () => {
      try {
        const query = new Parse.Query(className);

        query.equalTo("objectId", objectId);

        subscription = await query.subscribe();
        if (!isActive || !subscription) return;

        if (subscription.on) {
          subscription.on("open", () =>
            console.log("[useParseLiveQuery] subscription open"),
          );
          subscription.on("close", () =>
            console.log("[useParseLiveQuery] subscription close"),
          );
          subscription.on("error", (err) =>
            console.error("[useParseLiveQuery] subscription error", err),
          );
        }

        subscription.on("update", (obj) => {
          console.log("[useParseLiveQuery] update received", obj);
          setData(obj);
        });
      } catch (error) {
        console.error("[useParseLiveQuery] subscribe failed", error);
      }
    })();

    return () => {
      isActive = false;
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [className, objectId]);

  return data;
}
